import React from 'react'
import template from 'lodash/template'
import { deserializeTeam, fetchTeam } from 'supporticon/api/teams'

import Button from '../../ui/Button'
import Loading from '../../ui/Loading'
import RichText from '../../ui/RichText'
import Section from 'constructicon/section'
import Title from '../../ui/Title'

class TeamDetails extends React.Component {
  constructor () {
    super()
    this.state = {
      data: null,
      status: 'fetching'
    }
  }

  componentDidMount () {
    const { fundraisingPage } = this.props

    if (fundraisingPage.teamPageId) {
      return fetchTeam(fundraisingPage.teamPageId)
        .then(data => deserializeTeam(data))
        .then(data => this.setState({ data, status: 'fetched' }))
        .catch(error => {
          this.setState({ status: 'failed' })
          return Promise.reject(error)
        })
    }
  }

  render () {
    const { data, status } = this.state

    const {
      buttonBackground,
      buttonForeground,
      copy,
      cta,
      fundraisingPage,
      title
    } = this.props

    if (!fundraisingPage.teamPageId) {
      return null
    }

    if (status !== 'fetched') {
      return <Loading />
    }

    return (
      <div className='ssb-team-details'>
        {title && (
          <Title injectData={data}>
            {title}
          </Title>
        )}
        {copy && (
          <RichText injectData={data}>
            {copy}
          </RichText>
        )}
        {cta && (
          <Section spacing={{ t: 1 }}>
            <Button
              background={buttonBackground}
              foreground={buttonForeground}
              to={`/teams/${data.slug}`}>
              {template(cta)(data)}
            </Button>
          </Section>
        )}
      </div>
    )
  }
}

export default TeamDetails
